import { useState, useEffect, useRef } from 'react';
import { Box, Typography  } from '@mui/material';
import ProductRow from './productRow/ProductRow';
import ProductRowLoader from './productRow/ProductRowLoader';
import {useTheme} from '@mui/material';
import { getMarkets } from '../../api/market/marketApi';
import useProtectedClient from '../../hooks/useProtectedClient';
import { getJalaliTime } from '../../utils/helpers';

const MarketWidget = () => {
    const [isLoading, setIsLoading] = useState(true);
    const productItems = useRef([]);
    const marketName = useRef("");
    const isMarketOpen = useRef(false);
    const lastUpdate = useRef(false);
    const theme = useTheme();
    const protectedClient = useProtectedClient();


    useEffect( () => {
        const fetchMarkets = async () => {
            try {
                const res = await getMarkets(protectedClient);
                productItems.current = res.availableProducts
                isMarketOpen.current = res.isOpen
                lastUpdate.current = res.lastUpdate
                switch (res.marketId) {
                    case 1:
                        marketName.current = 'همکار'
                        break;
                    case 2:
                        marketName.current = 'عاملیت فروش'
                        break;
                    case 3:
                        marketName.current = ''
                        break;
                    case 4:
                        marketName.current = 'VIP'
                        break;
                    case 5:
                        marketName.current = 'CIP'
                        break;
                    case 6:
                        marketName.current = 'پرسنل زرید'
                        break;
                    default:
                        marketName.current = ''
                        break;
                }
            } catch (err) {
                console.log("Error refreshing token: ", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchMarkets();
        const intervalId = setInterval(() => {
            setIsLoading(true);
            fetchMarkets();
        }, 60000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                margin: '12px',
                marginBottom: '100px',
                borderRadius: '12px',
                background: theme.gradients.dark,
                boxShadow: 'none',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: '10px',
                    background: theme.palette.background.whiteOpacity,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        width: "90%",
                        backgroundColor: theme.palette.background.harmony,
                        borderRadius: "4px",
                        padding: "4px",
                        margin: "4px"
                    }}  
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start'
                        }}  
                    >
                        <Typography
                            variant='subtitle2'
                            color='textDefault'
                            sx={{ display: 'flex', flexDirection: 'row', flex: 1, alignItems: 'center', justifyContent: 'center', width: '100%', whiteSpace: 'nowrap', marginRight: '4px' }}
                        >
                            {"آخرین بروزرسانی"}
                        </Typography>
                        <Typography
                            variant='subtitle'
                            color='textDefault'
                            sx={{ display: 'flex', flexDirection: 'row', flex: 1, alignItems: 'center', justifyContent: 'center', width: '100%'}}
                        >
                            {getJalaliTime(lastUpdate.current)}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography
                            variant='subtitle2'
                            color='textDefault'
                            sx={{ display: 'flex', flexDirection: 'row', flex: 1, alignItems: 'center', justifyContent: 'center', width: '100%'}}
                        >
                            {`${marketName.current}`}
                        </Typography>
                    </Box>
                    
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        padding: '8px',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '30%',
                        }}
                    >
                        <Typography
                            variant='subtitle'
                            color='textSecondary'
                            sx={{  display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%'}}
                        >
                            قیمت خرید<span style={{ fontSize: '10px', marginRight: '2px', marginTop: '2px' }}>(تومان)</span>
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '30%',
                        }}
                    >
                        <Typography
                            variant='subtitle'
                            color='textSecondary'
                            sx={{ display: 'flex', flexDirection: 'row', flex: 1, alignItems: 'center', justifyContent: 'center', width: '100%'}}
                        >
                        کالاها
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '30%',
                        }}
                    >
                        <Typography
                            variant='subtitle'
                            color='textSecondary'
                            sx={{  display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%'}}
                        >
                            قیمت فروش<span style={{ fontSize: '10px', marginRight: '2px', marginTop: '2px' }}>(تومان)</span>
                        </Typography>
                    </Box>
                </Box>
            </Box>
            {!isLoading
            ? 
                <>
                    {isMarketOpen.current
                    ?
                        productItems.current
                        .filter(item => item.isActive)
                        .map((item, index) => (
                            <ProductRow
                                key={index}
                                item={item}
                            />
                        ))
                
                    :
                        <Typography
                            variant='caption'
                            color="textSecondary"
                            sx={{
                                margin: "30px"
                            }}
                        >
                            بازار بسته است!
                        </Typography>
                    }
                </>
            : 
                <>
                    <ProductRowLoader />
                    <ProductRowLoader />
                    <ProductRowLoader/>
                </>
            }
        </Box>
    );
};

export default MarketWidget;
